export const setMe = ({ peerId }) => ({
  type: "SET_ME",
  payload: { peerId },
});

export const setBrowser = (browser) => ({
  type: "SET_BROWSER",
  payload: { browser },
});

export const loggedIn = (flag) => ({
  type: "LOGGED_IN",
  payload: { flag },
});

export const addRole = (role) => ({
  type: "ADD_ROLE",
  payload: { role },
});

export const removeRole = (role) => ({
  type: "REMOVE_ROLE",
  payload: { role },
});

export const setPicture = (picture) => ({
  type: "SET_PICTURE",
  payload: { picture },
});

export const setMediaCapabilities = ({
  canSendMic,
  canSendWebcam,
  canShareScreen,
  canShareFiles,
}) => ({
  type: "SET_MEDIA_CAPABILITIES",
  payload: { canSendMic, canSendWebcam, canShareScreen, canShareFiles },
});

export const setDesktopCapabilities = ({ runtime, capabilities }) => ({
  type: "SET_DESKTOP_CAPABILITIES",
  payload: {
    runtime,
    canBeControlled: Boolean(capabilities && capabilities.canBeControlled),
  },
});

export const setAudioDevices = (devices) => ({
  type: "SET_AUDIO_DEVICES",
  payload: { devices },
});

export const setAudioOutputDevices = (devices) => ({
  type: "SET_AUDIO_OUTPUT_DEVICES",
  payload: { devices },
});

export const setWebcamDevices = (devices) => ({
  type: "SET_WEBCAM_DEVICES",
  payload: { devices },
});

export const setMyRaiseHandState = (flag) => ({
  type: "SET_MY_RAISE_HAND_STATE",
  payload: { flag },
});

export const setAudioInProgress = (flag) => ({
  type: "SET_AUDIO_IN_PROGRESS",
  payload: { flag },
});

export const setAudioOutputInProgress = (flag) => ({
  type: "SET_AUDIO_OUTPUT_IN_PROGRESS",
  payload: { flag },
});

export const setWebcamInProgress = (flag) => ({
  type: "SET_WEBCAM_IN_PROGRESS",
  payload: { flag },
});

export const setScreenShareInProgress = (flag) => ({
  type: "SET_SCREEN_SHARE_IN_PROGRESS",
  payload: { flag },
});

export const setMyRaiseHandStateInProgress = (flag) => ({
  type: "SET_MY_RAISE_HAND_STATE_IN_PROGRESS",
  payload: { flag },
});

export const setDisplayNameInProgress = (flag) => ({
  type: "SET_DISPLAY_NAME_IN_PROGRESS",
  payload: { flag },
});

export const setUIStep = (uiStep, uiStepParams) => ({
  type: "SET_UI_STEP",
  payload: { uiStep, uiStepParams },
});

export const clearState = () => ({
  type: "CLEAR_STATE",
});

export const setMainMenuSelection = (menu) => ({
  type: "SET_MAIN_MENU_SELECTION",
  payload: { menu },
});
